// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/slick-carousel/slick/slick-theme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Inter_28pt-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Inter_28pt-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Inter_28pt-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Inter28';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Inter28-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Inter28-SemiBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

/* Apply font to the whole page */
body {
  font-family: 'Inter28', sans-serif;
  font-size: 16px;

}

/* Force font for Ant Design components */
[class^="ant-"], [class*=" ant-"] {
  font-family: 'Inter28', sans-serif !important;
}

/* Set default font size for paragraph */
p, ul, li {
  font-size: 16px;
  line-height: 1.5;
  color: #212121;
  text-align: justify;
}

body, * {
  scrollbar-width: none;       /* Firefox */
  -ms-overflow-style: none;    /* IE/Edge */
}

body::-webkit-scrollbar, *::-webkit-scrollbar {
  display: none;               /* Chrome, Safari */
}

html, body, #root, .App {
  width: 100%;
  margin: 0;
  padding: 0;
}

@media screen and (max-width: 768px) {
   ul, li {
    text-align: left !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;EACE,sBAAsB;EACtB,+DAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,+DAAiE;EACjE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,+DAAqE;EACrE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,kCAAkC;EAClC,eAAe;;AAEjB;;AAEA,yCAAyC;AACzC;EACE,6CAA6C;AAC/C;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB,QAAQ,YAAY;EACzC,wBAAwB,KAAK,YAAY;AAC3C;;AAEA;EACE,aAAa,gBAAgB,mBAAmB;AAClD;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;GACG;IACC,2BAA2B;EAC7B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');\n@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\n\n@font-face {\n  font-family: 'Inter28';\n  src: url('./assets/fonts/Inter_28pt-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Inter28-Bold';\n  src: url('./assets/fonts/Inter_28pt-Bold.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Inter28-SemiBold';\n  src: url('./assets/fonts/Inter_28pt-SemiBold.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* Apply font to the whole page */\nbody {\n  font-family: 'Inter28', sans-serif;\n  font-size: 16px;\n\n}\n\n/* Force font for Ant Design components */\n[class^=\"ant-\"], [class*=\" ant-\"] {\n  font-family: 'Inter28', sans-serif !important;\n}\n\n/* Set default font size for paragraph */\np, ul, li {\n  font-size: 16px;\n  line-height: 1.5;\n  color: #212121;\n  text-align: justify;\n}\n\nbody, * {\n  scrollbar-width: none;       /* Firefox */\n  -ms-overflow-style: none;    /* IE/Edge */\n}\n\nbody::-webkit-scrollbar, *::-webkit-scrollbar {\n  display: none;               /* Chrome, Safari */\n}\n\nhtml, body, #root, .App {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n@media screen and (max-width: 768px) {\n   ul, li {\n    text-align: left !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
